<template>
  <section class="row" :id="id">
    <header class="col-xs-12">
      <h3>{{ title }}</h3>
    </header>
    <main class="col-xs-12">
      <data-table
        ref="vuetable"
        :title="title"
        :dados="itens"
        :fields="fields"
        :carregando="carregando"
        :per_page="10"
        @vuetable-pagination:change-page="checkAllCheckboxOnPage"
      >
        <template slot="header-actions">
          <div class="col-xs-12 col-sm-6 col-md-3" style="padding-left: 0">
            <label style="margin-bottom: 10px">Data Base</label>
            <datepicker v-model="dataBase" name="data_base" ref="data_base" />
          </div>
          <div
            class="container-action col-xs-12 col-sm-6 col-md-9"
            style="padding-left: 0"
          >
            <label>Ações</label>
            <div class="button-group">
              <button
                title="Selecionar todos os candidatos"
                @click="alternarTodosCheckboxNaPagina"
                class="btn btn-action btn-success btn-lg"
              >
                <font-awesome-icon
                  v-if="hasAllCheckboxOnPage"
                  :icon="iconChecked"
                  size="1x"
                />
                <font-awesome-icon v-else :icon="iconCheck" size="1x" />
              </button>
              <button
                title="Atualizar data de avaliação"
                @click="atualizarDataAvaliacaoSelecionados"
                class="btn btn-action btn-success btn-lg"
                :disabled="
                  !Boolean(dataBase) ||
                    allItensUnchecked ||
                    loading.atualizarDataAvaliacao
                "
              >
                <font-awesome-icon
                  v-if="loading.atualizarDataAvaliacao"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'calendar-check'" />
                <span class="sr-only">Atualizar Data de Avaliação</span>
              </button>
              <button
                title="Excluir"
                @click="excluirSelecionados"
                class="btn btn-action btn-success btn-lg"
                :disabled="allItensUnchecked || loading.excluir"
              >
                <font-awesome-icon
                  v-if="loading.excluir"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'trash-alt'" />
                <span class="sr-only">Excluir</span>
              </button>
              <button
                title="Imprimir fichas"
                @click="imprimirFichas"
                class="btn btn-action btn-success btn-lg"
                :disabled="!itens.length"
              >
                <font-awesome-icon
                  v-if="loading.imprimir"
                  :icon="'spinner'"
                  spin
                />
                <font-awesome-icon v-else :icon="'print'" />
                <span class="sr-only">Imprimir fichas</span>
              </button>
            </div>
          </div>
        </template>

        <template slot="column_input" slot-scope="props">
          <input type="checkbox" v-model="props.rowData.checked" />
        </template>

        <template slot="rowrender" slot-scope="props">
          <div class="button-group-row">
            <button
              title="Ausentar"
              class="btn btn-danger"
              @click="ausentar(props.rowData)"
            >
              <font-awesome-icon
                v-if="props.rowData.processingClickEvent.ausentar"
                :icon="'spinner'"
                spin
              />
              <font-awesome-icon v-else :icon="'minus-circle'" />
              <span class="sr-only">Excluir</span>
            </button>
            <button
              title="Reprovar"
              class="btn btn-danger"
              @click="reprovar(props.rowData)"
              :disabled="loading.reprovar"
            >
              <font-awesome-icon
                v-if="props.rowData.processingClickEvent.reprovar"
                :icon="'spinner'"
                spin
              />
              <font-awesome-icon v-else :icon="'user-times'" />
              <span class="sr-only">Excluir</span>
            </button>
            <button
              title="Excluir"
              class="btn btn-danger"
              @click="excluir(props.rowData)"
              :disabled="loading.excluir"
            >
              <font-awesome-icon
                v-if="props.rowData.processingClickEvent.excluir"
                :icon="'spinner'"
                spin
              />
              <font-awesome-icon v-else :icon="'trash-alt'" />
              <span class="sr-only">Excluir</span>
            </button>
          </div>
        </template>
      </data-table>
    </main>
  </section>
</template>

<script>
import { request } from '@/request'
import DataTable from '@/components/common/NoApiTable'
import Datepicker from '@/components/common/Datepicker'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'

export default {
  components: { DataTable, Datepicker },
  props: {
    id: {
      type: String,
      default() {
        return ''
      }
    },
    title: {
      type: String,
      default() {
        return 'Listagem'
      }
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    carregando: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      dataBase: '',
      loading: {
        atualizarDataAvaliacao: false,
        imprimir: false,
        excluir: false
      },
      hasAllCheckboxOnPage: false,
      lastPageSelected: 1,
      itens: [],
      fields: [
        {
          name: '__slot:input',
          title: '#',
          dataClass: 'text-center'
        },
        {
          name: 'classificacao',
          title: 'Classificação',
          dataClass: 'text-center'
        },
        {
          name: 'inscricao',
          title: 'Inscrição',
          dataClass: 'text-center'
        },
        {
          name: 'cargo.descricao',
          title: 'Cargo'
        },
        {
          name: 'nome',
          title: 'Nome'
        },
        {
          name: 'negro',
          title: 'Negro',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'deficiente',
          title: 'Deficiente',
          dataClass: 'text-center',
          callback: value => {
            return value === 1 ? 'Sim' : 'Não'
          }
        },
        {
          name: 'avaliacao_status',
          title: 'Status',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: 'data_avaliacao',
          title: 'Data Avaliação'
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ]
    }
  },
  mounted() {
    this.setItens()
  },
  computed: {
    iconCheck() {
      return faSquare
    },
    iconChecked() {
      return faCheckSquare
    },
    allItensUnchecked() {
      return this.itens.filter(item => item.checked).length === 0
    }
  },
  watch: {
    data: function(val, oldVal) {
      this.setItens()
    }
  },
  methods: {
    imprimirFichas() {
      const { edital_id } = _.first(this.itens)
      window.open(
        `${process.env.BACKEND}prehabilitado/imprimir-fichas-cotas/${edital_id}`,
        '_blank'
      )
    },
    ausentar({ id, index, nome }) {
      const { showConfirm, sendRequestUpdate } = this
      const title = 'Confirmar ausência'
      const msg = `Tem certeza que deseja <b>ausentar</b> ${nome}`
      const status = 'AUSENTE'
      const params = { id, data: { avaliacao_status: status } }
      const msgSuccess = `${nome} está como AUSENTE`
      const msgError = `Não foi possivel ausentar ${nome}, por favor tente daqui alguns minutos!`
      const success = () =>
        sendRequestUpdate({
          index,
          action: 'ausentar',
          params,
          msgSuccess,
          msgError,
          status
        })

      showConfirm({ title, msg, success })
    },
    reprovar({ id, index, nome }) {
      const { showConfirm, sendRequestUpdate } = this
      const title = 'Confirmar reprovação'
      const msg = `Tem certeza que deseja <b>reprovar</b> ${nome}`
      const status = 'REPROVADO'
      const params = { id, data: { avaliacao_status: status } }
      const msgSuccess = `${nome} está como REPROVADO`
      const msgError = `Não foi possivel reprovar ${nome}, por favor tente daqui alguns minutos!`
      const success = () =>
        sendRequestUpdate({
          index,
          action: 'ausentar',
          params,
          msgSuccess,
          msgError,
          status
        })

      showConfirm({ title, msg, success })
    },
    excluir({ id, index, nome }) {
      const { showConfirm, sendRequestDelete } = this
      const title = 'Confirmar exclusão'
      const msg = `Tem certeza que deseja <b>excluir</b> ${nome}`
      const params = { id }
      const msgSuccess = `${nome} excluido com sucesso.`
      const msgError = `Não foi possivel excluir ${nome}, por favor tente daqui alguns minutos!`
      const success = () =>
        sendRequestDelete({ index, params, msgSuccess, msgError })

      showConfirm({ title, msg, success })
    },
    sendRequestUpdate({ index, action, params, msgSuccess, msgError, status }) {
      const { toggleProcessingClickEvent } = this
      const url = `prehabilitados/${params.id}`
      const onCatch = () => this.$toastr.e(msgError)
      const onFinally = () => toggleProcessingClickEvent(index, action)

      toggleProcessingClickEvent(index, action)

      request
        .put(url, params)
        .then(() => {
          this.itens[index].avaliacao_status = status
          this.$toastr.s(msgSuccess)
        })
        .catch(onCatch)
        .finally(onFinally)
    },
    sendRequestDelete({ index, params, msgSuccess, msgError }) {
      const { toggleProcessingClickEvent } = this
      const url = `prehabilitados/${params.id}`
      const onCatch = () => {
        toggleProcessingClickEvent(index, 'excluir')
        this.$toastr.e(msgError)
      }

      toggleProcessingClickEvent(index, 'excluir')

      request
        .delete(url)
        .then(() => {
          toggleProcessingClickEvent(index, 'excluir')
          this.itens = this.itens.filter(item => item.id != params.id)
          this.$toastr.s(msgSuccess)
        })
        .catch(onCatch)
    },
    atualizarDataAvaliacaoSelecionados() {
      const {
        itens,
        toggleLoadingActionButton,
        updateStatusRowsSelected,
        resetAllCheckbox
      } = this
      const id = itens
        .filter(item => item.checked)
        .map(item => item.id)
        .join(',')
      const params = {
        data: {
          data_avaliacao: this.dataBase.toJSON().split('T')[0]
        }
      }

      toggleLoadingActionButton('atualizarDataAvaliacao')

      request
        .put(`prehabilitados/${id}`, params)
        .then(() => {
          updateStatusRowsSelected({
            data_avaliacao: this.dataBase.toLocaleDateString()
          })
          resetAllCheckbox()
          this.$toastr.s('Datas de avaliação atualizadas com sucesso.')
        })
        .catch(() => this.$toastr.e(msgError))
        .finally(() => this.toggleLoadingActionButton('atualizarDataAvaliacao'))
    },
    excluirSelecionados() {
      const {
        showConfirm,
        itens,
        toggleLoadingActionButton,
        alternarTodosCheckboxNaPagina
      } = this
      const preHabilitadoSelecionados = itens
        .filter(item => item.checked)
        .map(({ id, nome }) => ({ id, nome }))
      const success = () => {
        const ids = preHabilitadoSelecionados.map(({ id }) => id).join(',')
        toggleLoadingActionButton('excluir')

        request
          .delete(`prehabilitados/${ids}`)
          .then(() => {
            this.itens = this.itens.filter(item => !ids.includes(item.id))
            alternarTodosCheckboxNaPagina()
            this.$toastr.s(
              `${preHabilitadoSelecionados.length} registros foram excluidos com sucesso.`
            )
          })
          .catch(() =>
            this.$toastr.e(
              `Não foi possivel excluir os itens selecionados, por favor tente daqui alguns minutos!`
            )
          )
          .finally(() => toggleLoadingActionButton('excluir'))
      }

      showConfirm({
        title: 'Confirmar exclusão',
        msg: preHabilitadoSelecionados
          .map(({ nome }) => `<p>${nome}</p>`)
          .join(''),
        success
      })
    },
    alternarTodosCheckboxNaPagina() {
      const statusCurrent = this.hasAllCheckboxOnPage

      this.$refs.vuetable.tableData.forEach(item => {
        item.checked = !statusCurrent
      })

      this.hasAllCheckboxOnPage = !statusCurrent
    },
    showConfirm({ title, msg, success }) {
      const { modal } = this.$router.app.$refs
      modal.confirm(msg, { title, question: true, yes: success })
    },
    setItens() {
      const { data } = this
      this.itens = data.map((item, index) => ({
        index,
        checked: false,
        processingClickEvent: {
          ausentar: false,
          reprovar: false,
          excluir: false
        },
        ...item
      }))
    },
    toggleProcessingClickEvent(index, action) {
      const item = this.itens[index]
      this.itens[index].processingClickEvent[action] = !item
        .processingClickEvent[action]
    },
    toggleLoadingActionButton(action) {
      this.loading[action] = !this.loading[action]
    },
    updateStatusRowsSelected(keyValue) {
      const key = Object.keys(keyValue)
      const value = keyValue[key]

      this.itens
        .filter(item => item.checked)
        .forEach(item => (item[key] = value))
    },
    checkAllCheckboxOnPage() {
      const { tableData } = this.$refs.vuetable
      const countSelected = tableData
        .map(({ checked }) => +checked)
        .reduce((acc, cur) => acc + cur)

      this.hasAllCheckboxOnPage = countSelected === tableData.length
    },
    resetAllCheckbox() {
      this.itens
        .filter(item => item.checked)
        .forEach(item => (item.checked = false))
    }
  }
}
</script>

<style scoped>
.button-group {
  display: flex;
}
.button-group > * {
  margin-right: 4px;
}
.btn-action {
  color: #468b35;
  border: none;
  transition: 0.4s;
}
.btn-action:hover {
  color: #468b35 !important;
  background-color: rgba(68, 157, 68, 0.2) !important;
}
.btn-action:focus-visible {
  border: none;
}
.btn-action:active,
.btn-action:focus {
  color: #468b35;
  background-color: transparent;
  outline: none;
}
.button-group-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: nowrap;
  width: 100%;
}
.button-group-row > button {
  margin-right: 5px;
}
.button-group-row > button:last-child {
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/PreHabilitadoTable/index.vue